"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license. See LICENSE file in the project root for details.
Object.defineProperty(exports, "__esModule", { value: true });
exports.enablePublishers = void 0;
const api_1 = require("@opentelemetry/api");
const TAG = "DiagnosticChannel";
let isInitialized = false;
function enablePublishers() {
    // Only register monkey patchs once
    if (!isInitialized) {
        isInitialized = true;
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const publishers = require("diagnostic-channel-publishers");
        const modules = {
            console: publishers.console,
        };
        for (const mod in modules) {
            modules[mod].enable();
            api_1.diag.info(TAG, `Subscribed to ${mod} events`);
        }
    }
}
exports.enablePublishers = enablePublishers;
//# sourceMappingURL=initialization.js.map